<template>
  <div>
    <b-modal id="traveller-existing" ref="traveller-existing" v-model="showModal" centered
             :title="$t('traveller.add.existing')" @ok="ok" @cancel="cancel" :ok-title="$t('_yes')" :cancel-title="$t('_no')" :no-enforce-focus="true" :hide-header-close="true"
    >
      <div class="row justify-content-center d-block">
        <p class="col-12 text-center mb-2">
          Attention un(e) voyageur(se) existe déjà avec
          <span v-for="(param, index) in paramsExisting" v-bind:key="index">
            <span v-if="index > 0"> et </span>
            <span v-if="param === 'lastName'">ce nom</span>
            <span v-if="param === 'email'">cette adresse email</span>
          </span>.
        </p>
        <p class="col-12 text-center mb-2 font-weight-bold">Merci de vérifier avant de confirmer cette création.</p>
        <p class="col-12 text-center">Souhaitez-vous le(s) ajouter quand même ?</p>
      </div>
    </b-modal>
  </div>
</template>

<script>

import textInput from '@/components/frontoffice/form/baseInput/text'

export default {
  components: {
    textInput
  },

  props: {
    paramsExisting: Array
  },
  data () {
    return {
      showModal: false,
      valid: false
    }
  },

  methods: {
    ok (event) {
      this.valid = true
      this.$emit('ok')
    },

    cancel () {
      this.$emit('cancel', this.valid)
    }
  }
}
</script>

<style scoped>

</style>
